import React from "react";
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import { withStyles } from "@material-ui/core/styles";
import PageTitle from "../../components/common/PageTitle";
import Button from "@material-ui/core/Button";

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import  api from '../common/api';

import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';


const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem',
  },
});

class ClientGroup extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			dialogOpen: false,
			loading: true,
			errors: false,
			client_group:{
			},
		}
	}

	async componentDidMount() {
		var params = this.getParams();
		var client_group_id = params.id
		var view = params.view
		if (client_group_id !== undefined){
			await this.getClientGroup(client_group_id);
			if (view !== undefined){
				this.setState({disabled: true, action: 'view'})
			} else {
				this.setState({action: 'edit'})
			}
		} else {
			this.setState({action: 'new', loading: false})
		}
	}

	getParams(){
		return this.props.match.params
	}

	getClientGroup(id){
	    const token = localStorage.getItem('userToken')
	    return axios
	         .get(api.client_groups().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	          .then(res => {
	              res.data = Object.values(res.data);
	              this.setState({client_group: res.data[0], loading: false })
	              return res.data
	          })
	          .catch(err =>{console.log(err)
	          })
	}

 	handleChange = (event) => {
	    event.preventDefault();	
	    var key = event.target.name
	    var value = event.target.value
	    var client_group = this.state.client_group
	    client_group[key] = value
	    this.setState({client_group: client_group})
 	}

   handleSubmit = (event) => {
	    event.preventDefault();
	    event.stopPropagation();
	    var formData = new FormData();
	    formData.set("client_group[name]", this.state.client_group.name);

		let self = this
		const token =localStorage.getItem('userToken')
		if (this.state.action ==='new'){
		  axios.post(api.client_groups().post(),
		     formData,
		     {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
		     )
		    .then((response)=> {
		        self.setState({errors: false, saved: true})
		        self.setState({message: 'Grupo creado con éxito!'})
		        self.setState({dialogOpen: true})
		    })
		    .catch(function (error) {
		        self.setState({errors: true})
		        self.setState({message: 'Hubo un problema al guardar el grupo. Por favor volver a intentar'})
		        self.setState({dialogOpen: true})
		  })
		} else {
			formData.set('client_group[id]', this.state.client_group.id)
			formData.append('_method', 'patch');
			axios.post(api.client_groups().patch(this.state.client_group.id),
			   formData,
			   {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
			   )
			  .then((response)=> {
			      self.setState({errors: false, saved: true})
			      self.setState({message: 'Grupo modificado con éxito!'})
			      self.setState({dialogOpen: true})
			  })
			  .catch(function (error) {
			      self.setState({errors: true, saved: false})
			      self.setState({message: 'Hubo un problema al guardar el grupo. Por favor volver a intentar'})
			      self.setState({dialogOpen: true})
			})

		}
	}

	render(){
	    const handleRedirect = id => () =>{
	      window.location.href=`/client_groups`
	    }

	    const handleDialogClose = () => {
	      this.setState({dialogOpen: false})
	    }        

	    const disabled = this.state.disabled
	    const client_group = this.state.client_group
		const classes = this.props.classes;
		return(
	       <Container fluid className="main-content-container px-4 pb-4">
	          <Row noGutters className="page-header pt-4">
	            <PageTitle sm="4" title={(client_group.id !== undefined) ? client_group.name : "Nuevo grupo"} className="text-sm-left" />
	          </Row>
	          <Row>
	            <Col md="12">
	              <React.Fragment>
	              {(this.state.dialogOpen)?
	                <Dialog
	                  open={this.state.dialogOpen}
	                  fullWidth
	                  aria-labelledby="responsive-dialog-title"
	                >
	                  <DialogTitle id="responsive-dialog-title">{"Grupo"}</DialogTitle>
	                  <DialogContent>
	                    <DialogContentText>
	                        {this.state.message}
	                    </DialogContentText>
	                  </DialogContent>
	                  <DialogActions disableSpacing="false">  
                      {(this.state.saved)?
                        <Button onClick={handleRedirect()} variant="contained" color="primary" >
                            Aceptar
                        </Button>
                        :
                        ''
                       }
	                  {(this.state.errors) ?
	                      <Button onClick={handleDialogClose} variant="contained" color="primary" >
	                          Aceptar
	                      </Button>
	                      :
	                      ''
	                    }

	                  </DialogActions>
	                </Dialog>
	              :''}
	              {(this.state.loading)?
	                 <LinearProgress /> 
	              :
	              <div>
	                <form onSubmit={this.handleSubmit}>
	                	<div>
							<TextField
								id="name"
								name="name"
								label="Nombre grupo"
								disabled={disabled}
								type="text"
								required
								placeholder="Ingrese el nombre del grupo de cliente"
								onChange={this.handleChange}
								value={client_group.name}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
                        </div>
		                {(this.state.action !== 'view')?
		                  <React.Fragment>
		                    <Button type="submit" variant="contained" className="mt-3 ml-1 mr-1"  color="primary">
		                      Guardar
		                    </Button>
		                    <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/client_groups"}>
		                      Cancelar
		                    </Button>
		                  </React.Fragment>
		                :
		                  <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/client_groups"}>
		                    Volver
		                  </Button>
		                }
	              </form>
	            </div>
	            }
	            </React.Fragment>
	          </Col>
	        </Row>
	      </Container>

		)
	}  

}

export default withStyles(useStyles)(ClientGroup);